import { useUserQuery } from '../gen/user'
import { isLoggedInQuerySelector } from '../selectors'
import { USER_ROLES } from 'constants/user'

export function useAuthContext() {
  const { data } = useUserQuery()
  const userData =
    data?.me?.user && isLoggedInQuerySelector(data)
      ? {
          id: data.me.user.id,
          firstName: data.me.user.firstName,
          lastName: data.me.user.lastName,
          avatarUrl: data.me.user.avatarUrl,
          slug: data.me.user.slug,
        }
      : undefined

  return { userData }
}

export function useIsAuthPending() {
  const { isPending } = useUserQuery()
  return isPending
}

export function useUserData() {
  const { userData } = useAuthContext()
  return userData
}

export function useUserId() {
  const { userData } = useAuthContext()
  return userData?.id
}

export function useIsLoggedIn() {
  const { userData } = useAuthContext()
  return !!userData
}

export function useStoreSlug() {
  const { data } = useUserQuery(undefined, {
    select: data =>
      data?.me?.user?.roles?.includes(USER_ROLES.DESIGNER) ? (data?.me?.user?.slug ?? '') : '',
  })
  return data ?? ''
}

export function useUserLanguage() {
  const { data } = useUserQuery()
  return data?.me?.user?.language
}

export function useHasAllAccess() {
  const { data } = useUserQuery(undefined, {
    select: data => data?.me?.user?.subscriptionAccess.allAccess.isSubscribed ?? false,
  })
  return data ?? false
}

export function useHasAllAccessWithPending() {
  const { data, isPending } = useUserQuery(undefined, {
    select: data => data?.me?.user?.subscriptionAccess.allAccess.isSubscribed ?? false,
  })

  return {
    hasAllAccess: data ?? false,
    isPending,
  }
}

export function useHasActiveSubscription() {
  const { data } = useUserQuery(undefined, {
    select: data =>
      data?.me?.user?.subscriptionAccess.allAccess.isSubscribed ||
      data?.me?.user?.subscriptionAccess.studioAi.isSubscribed ||
      false,
  })
  return data ?? false
}

export function useHasActiveSubscriptionWithPending() {
  const { data, isPending } = useUserQuery(undefined, {
    select: data =>
      data?.me?.user?.subscriptionAccess.allAccess.isSubscribed ||
      data?.me?.user?.subscriptionAccess.studioAi.isSubscribed ||
      false,
  })

  return {
    hasActiveSubscription: data ?? false,
    isPending,
  }
}
